module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('table-list', {
    attrs: {
      "records": _vm.audits,
      "fields": _vm.fields,
      "has-edit": "/local-audits/{?}",
      "row-clickable": "true"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cdcc1ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LocalAudits.vue
// module id = 300
// module chunks = 0